export const isSpaceKey = (key: string): boolean => key === ' '
export const isEnterKey = (key: string): boolean => key === 'Enter'
export const isArrowKeys = (key: string): boolean => key.indexOf('Arrow') === 0

export const isHomeOrEndKeys = (key: string): boolean =>
  key === 'Home' || key === 'End'

export const isPageKeys = (key: string): boolean => key.indexOf('Page') === 0

export const isKeyboardEvent = (
  event: any
): event is React.KeyboardEvent<HTMLElement> => !!event.key

export const isNavigationKey = (key: string) =>
  isHomeOrEndKeys(key) || isArrowKeys(key) || isPageKeys(key) || isSpaceKey(key)

// Non printable keys have a name, e.g. "ArrowRight", see the whole list:
// https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
// We need to ignore shortcuts, for example: select all:
// - Windows: Ctrl+A, event.ctrlKey is true
// - macOS: ⌘ Command+A, event.metaKey is true
export function isPrintableKey(
  event: React.KeyboardEvent<HTMLElement>
): boolean {
  return (
    event.key.length === 1 && event.ctrlKey === false && event.metaKey === false
  )
}
